// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * @license
 * Copyright 2024 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

.neuroglancer-tool-palette-button-container {
  display: inline-flex;
  flex-direction: row;
}

.neuroglancer-tool-palette-button-container {
  border-radius: 20%;
  border: 1px solid transparent;
}

.neuroglancer-tool-palette-button-container:hover {
  background-color: #484848;
}

.neuroglancer-tool-palette-button {
  position: relative;
  display: flex;
  flex-direction: row;
}

.neuroglancer-tool-palette-dropdown {
  position: absolute;
  z-index: 100;
  min-width: min(50vw, 300px);
  border: 1px solid #aaa;
  background-color: black;
  padding: 2px;
}

.neuroglancer-tool-palette-name {
  flex: 1;
  background-color: transparent;
  border: 0px;
  color: white;
  outline: 0px;
  /* ensure if name gets too long it doesn't push buttons over */
  width: 0px;
  min-width: 0px;
}

.neuroglancer-tool-palette-dropdown > ul {
  overflow-y: auto;
  padding: 0px;
  margin: 0px;
}

.neuroglancer-tool-palette-dropdown
  > ul
  > li:not(.neuroglancer-tool-palette-dropdown-separator) {
  display: flex;
  flex-direction: row;
  list-style-type: none;
  padding: 2px;
  font: 10pt sans-serif;
}

.neuroglancer-tool-palette-dropdown
  > ul
  > li:not(.neuroglancer-tool-palette-dropdown-separator):hover {
  background-color: #333;
}

.neuroglancer-tool-palette-dropdown-canned-item {
  cursor: pointer;
}

.neuroglancer-tool-palette-dropdown-separator {
  height: 1px;
  margin-top: 3px;
  margin-bottom: 3px;
  padding: 0px;
  background-color: #ccc;
}

.neuroglancer-tool-palette-drop-zone {
  display: block;
  flex: 1;
}

.neuroglancer-tool-palette-items {
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  flex-shrink: 1;
  flex-basis: 0px;
  font: 10pt sans-serif;
  overflow-y: auto;
  overflow-x: hidden;
}

.neuroglancer-tool-palette-tool-container {
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  padding-top: 2px;
  padding-bottom: 2px;
}

.neuroglancer-tool-palette-tool-container:hover {
  background-color: #282828;
}

.neuroglancer-tool-palette-tool-container
  > .neuroglancer-tool-palette-tool-content {
  grid-row: 1;
  grid-column: 2;
}

.neuroglancer-tool-palette-tool-container
  > .neuroglancer-tool-palette-tool-properties {
  grid-row: 2;
  grid-column: 1/3;
}

.neuroglancer-tool-palette-tool-container > .neuroglancer-tool-key-binding {
  grid-row: 1;
  grid-column: 1;
}

.neuroglancer-tool-palette-tool-delete {
  visibility: hidden;
}

.neuroglancer-tool-palette-tool-container:hover
  > .neuroglancer-tool-palette-tool-delete {
  visibility: inherit;
}

.neuroglancer-tool-palette-layer-group-header {
  display: flex;
  flex-direction: row;
  background-color: #181818;
  border-bottom: 2px solid black;
  position: sticky;
  top: 0px;
  z-index: 1;
}

.neuroglancer-tool-palette-layer-group:hover
  > .neuroglancer-tool-palette-layer-group-header {
  background-color: #282828;
}

.neuroglancer-tool-palette-layer-group {
  border-left: 2px solid #181818;
}

.neuroglancer-tool-palette-layer-group:hover {
  border-left: 2px solid #ccc;
}

.neuroglancer-tool-palette-body {
  display: flex;
  flex-direction: column;
  flex: 1;
}

.neuroglancer-tool-palette-body .neuroglancer-multiline-autocomplete-dropdown {
  z-index: 2;
}

.neuroglancer-tool-palette-query-errors {
  margin: 0px;
  padding: 0px;
  margin-bottom: 2px;
}

.neuroglancer-tool-palette-query-errors > li {
  list-style-type: none;
  padding: 2px;
  font: 10pt sans-serif;
  color: red;
}

.neuroglancer-tool-palette-tool-properties {
  display: none;
  color: #f9f;
  font-style: italic;
  user-select: text;
}

.neuroglancer-tool-palette-show-properties
  .neuroglancer-tool-palette-tool-properties {
  display: block;
}

.neuroglancer-tool-to-be-removed {
  opacity: 50%;
}
`, "",{"version":3,"sources":["webpack://./node_modules/neuroglancer/lib/ui/tool_palette.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;EAcE;;AAEF;EACE,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,2BAA2B;EAC3B,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,OAAO;EACP,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,8DAA8D;EAC9D,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;AACb;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;AACvB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,OAAO;AACT;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,WAAW;EACX,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,gBAAgB;EAChB,QAAQ;EACR,UAAU;AACZ;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,OAAO;AACT;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,YAAY;EACZ,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd","sourcesContent":["/**\n * @license\n * Copyright 2024 Google Inc.\n * Licensed under the Apache License, Version 2.0 (the \"License\");\n * you may not use this file except in compliance with the License.\n * You may obtain a copy of the License at\n *\n *      http://www.apache.org/licenses/LICENSE-2.0\n *\n * Unless required by applicable law or agreed to in writing, software\n * distributed under the License is distributed on an \"AS IS\" BASIS,\n * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.\n * See the License for the specific language governing permissions and\n * limitations under the License.\n */\n\n.neuroglancer-tool-palette-button-container {\n  display: inline-flex;\n  flex-direction: row;\n}\n\n.neuroglancer-tool-palette-button-container {\n  border-radius: 20%;\n  border: 1px solid transparent;\n}\n\n.neuroglancer-tool-palette-button-container:hover {\n  background-color: #484848;\n}\n\n.neuroglancer-tool-palette-button {\n  position: relative;\n  display: flex;\n  flex-direction: row;\n}\n\n.neuroglancer-tool-palette-dropdown {\n  position: absolute;\n  z-index: 100;\n  min-width: min(50vw, 300px);\n  border: 1px solid #aaa;\n  background-color: black;\n  padding: 2px;\n}\n\n.neuroglancer-tool-palette-name {\n  flex: 1;\n  background-color: transparent;\n  border: 0px;\n  color: white;\n  outline: 0px;\n  /* ensure if name gets too long it doesn't push buttons over */\n  width: 0px;\n  min-width: 0px;\n}\n\n.neuroglancer-tool-palette-dropdown > ul {\n  overflow-y: auto;\n  padding: 0px;\n  margin: 0px;\n}\n\n.neuroglancer-tool-palette-dropdown\n  > ul\n  > li:not(.neuroglancer-tool-palette-dropdown-separator) {\n  display: flex;\n  flex-direction: row;\n  list-style-type: none;\n  padding: 2px;\n  font: 10pt sans-serif;\n}\n\n.neuroglancer-tool-palette-dropdown\n  > ul\n  > li:not(.neuroglancer-tool-palette-dropdown-separator):hover {\n  background-color: #333;\n}\n\n.neuroglancer-tool-palette-dropdown-canned-item {\n  cursor: pointer;\n}\n\n.neuroglancer-tool-palette-dropdown-separator {\n  height: 1px;\n  margin-top: 3px;\n  margin-bottom: 3px;\n  padding: 0px;\n  background-color: #ccc;\n}\n\n.neuroglancer-tool-palette-drop-zone {\n  display: block;\n  flex: 1;\n}\n\n.neuroglancer-tool-palette-items {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n  flex-shrink: 1;\n  flex-basis: 0px;\n  font: 10pt sans-serif;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n.neuroglancer-tool-palette-tool-container {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  align-items: center;\n  padding-top: 2px;\n  padding-bottom: 2px;\n}\n\n.neuroglancer-tool-palette-tool-container:hover {\n  background-color: #282828;\n}\n\n.neuroglancer-tool-palette-tool-container\n  > .neuroglancer-tool-palette-tool-content {\n  grid-row: 1;\n  grid-column: 2;\n}\n\n.neuroglancer-tool-palette-tool-container\n  > .neuroglancer-tool-palette-tool-properties {\n  grid-row: 2;\n  grid-column: 1/3;\n}\n\n.neuroglancer-tool-palette-tool-container > .neuroglancer-tool-key-binding {\n  grid-row: 1;\n  grid-column: 1;\n}\n\n.neuroglancer-tool-palette-tool-delete {\n  visibility: hidden;\n}\n\n.neuroglancer-tool-palette-tool-container:hover\n  > .neuroglancer-tool-palette-tool-delete {\n  visibility: inherit;\n}\n\n.neuroglancer-tool-palette-layer-group-header {\n  display: flex;\n  flex-direction: row;\n  background-color: #181818;\n  border-bottom: 2px solid black;\n  position: sticky;\n  top: 0px;\n  z-index: 1;\n}\n\n.neuroglancer-tool-palette-layer-group:hover\n  > .neuroglancer-tool-palette-layer-group-header {\n  background-color: #282828;\n}\n\n.neuroglancer-tool-palette-layer-group {\n  border-left: 2px solid #181818;\n}\n\n.neuroglancer-tool-palette-layer-group:hover {\n  border-left: 2px solid #ccc;\n}\n\n.neuroglancer-tool-palette-body {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n}\n\n.neuroglancer-tool-palette-body .neuroglancer-multiline-autocomplete-dropdown {\n  z-index: 2;\n}\n\n.neuroglancer-tool-palette-query-errors {\n  margin: 0px;\n  padding: 0px;\n  margin-bottom: 2px;\n}\n\n.neuroglancer-tool-palette-query-errors > li {\n  list-style-type: none;\n  padding: 2px;\n  font: 10pt sans-serif;\n  color: red;\n}\n\n.neuroglancer-tool-palette-tool-properties {\n  display: none;\n  color: #f9f;\n  font-style: italic;\n  user-select: text;\n}\n\n.neuroglancer-tool-palette-show-properties\n  .neuroglancer-tool-palette-tool-properties {\n  display: block;\n}\n\n.neuroglancer-tool-to-be-removed {\n  opacity: 50%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
